'use cient';
import React, { FC, useEffect, useState } from 'react';
import { Select, SelectProps } from 'antd';
import { useConnection } from '@sezenta/connection';

type Props = {
  type?: string | number;
  url?: string;
} & SelectProps;

export const EnumInput: FC<Props> = (props) => {
  const connection = useConnection();
  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setLoading(true);
    connection
      .get(props.url ?? `master-data/enums/${props.type}`)
      .then((value) =>
        value.data.sort((a: any, b: any) => a.label.localeCompare(b.label)),
      )
      .then(setOptions)
      .finally(() => setLoading(false));
  }, [connection, props.type, props.url]);
  return (
    <Select
      optionFilterProp={'label'}
      showSearch={true}
      loading={loading}
      {...props}
      options={options}
    />
  );
};
